import React from 'react';
import { Checkbox, withStyles } from "@material-ui/core";
import { font } from "../styles/styles";

export const CustomCheckbox = withStyles({
    root: {
      color: font.baseCheckboxColor,
      '&$checked': {
        color: font.baseColor,
      },
      '&$.Mui-disabled': {
        color: 'transparent'
      },
    },
    checked: {},
    disabled:{}
  })((properties) => <Checkbox color="default" {...properties} />);